import type { SummariesLabelsType } from '@sravni/package-bdui-utils';

type TSummaryItem = {
  label: SummariesLabelsType;
  value: string | number;
};

export const getSummaryValue = (summaries: TSummaryItem[] | undefined, summaryLabel: SummariesLabelsType) =>
  summaries?.find((summary) => summary.label === summaryLabel)?.value;

export const getSummaryStringValue = (summaries: TSummaryItem[] | undefined, summaryLabel: SummariesLabelsType) => {
  const value = getSummaryValue(summaries, summaryLabel);
  return value !== undefined ? String(value) : undefined;
};
